type FillAccountError = {
  emptyLastName: boolean;
  emptyFirstName: boolean;
  invalidPassword: {
    doesNotHaveUpper: boolean;
    doesNotHaveNumberOrSpecialChar: boolean;
    isTooShort: boolean;
  };
  alreadyConfirmed: boolean;
};

const fillAccountError: FillAccountError = {
  emptyFirstName: false,
  emptyLastName: false,
  invalidPassword: {
    doesNotHaveUpper: false,
    doesNotHaveNumberOrSpecialChar: false,
    isTooShort: false,
  },
  alreadyConfirmed: false,
};

export type { FillAccountError };

export { fillAccountError };
